
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { authorizeUserServerSide } from 'api/firebaseAdmin';
import classNames from 'classnames';
import AppLink from 'components/AppLink/AppLink';
import DeviceList from 'components/DeviceList';
import Layout from 'components/Layout';
import { useAuth } from 'context';
import { useLang } from 'context/langContext';
import { Namespace } from 'enums';
import { basicSEO, createRedirectIfNeeded, getNoTrialTranslationKeyIfNeeded, Permalink } from 'helpers';
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import { useMemo } from 'react';
import { StaticPathParams } from 'typings/staticPaths';
import indexStyles from '../index.module.scss';
import styles from './index.module.scss';

interface Props {
  countryCode: string;
}

const HowToWatchMobile = ({ countryCode }: Props): JSX.Element => {
  const { t } = useTranslation(Namespace.HowToWatch);
  const { locale } = useLang();
  const { user } = useAuth();

  return (
    <Layout countryCode={countryCode}>
      <Head>
        {basicSEO(
          t('seo:how_to_watch_mobile_title'),
          t(getNoTrialTranslationKeyIfNeeded('seo:how_to_watch_mobile_description', countryCode)),
        )}
      </Head>
      <main className={classNames(indexStyles.container, styles['smart-tv'])}>
        <h1>{t('title')}</h1>
        <DeviceList activeIndex={2} />
        <ul className={indexStyles.blocks}>
          <li>
            <h2 className={styles.android}>{t('mobile.android_title')}</h2>
            <p>{t('mobile.android_description')}</p>
            <AppLink href={Permalink.howToWatchMobileAndroid(locale)}>
              <a className={classNames('btn', 'btn-primary')}>{t('mobile.button')}</a>
            </AppLink>
          </li>
          <li>
            <h2 className={styles.apple}>{t('mobile.ios_title')}</h2>
            <p>{t('mobile.ios_description')}</p>
            <AppLink href={Permalink.howToWatchMobileIOS(locale)}>
              <a className={classNames('btn', 'btn-primary')}>{t('mobile.button')}</a>
            </AppLink>
          </li>
        </ul>
      </main>
    </Layout>
  );
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { locale, apiClient, countryCode } = await authorizeUserServerSide(ctx);

  const redirect = createRedirectIfNeeded(ctx, locale);
  if (redirect) {
    return redirect;
  }

  return {
    props: { countryCode },
  };
}

export default HowToWatchMobile;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/how-to-watch/mobile-apps/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  